import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import About from './Pages/About';
import Partnerships from './Components/partnership/Partnerships.js';
import Careers from './Components/careers/Careers.js';
import ComingSoon from './Pages/ComingSoon';
import NotFound from './Pages/NotFound';
import AcademicCourses from './Pages/AcademicCourses';
import CollegeCounseling from './Pages/CollegeCounseling';
import TutorBrowserPage from './Pages/tutor/index.jsx';
import TutorDetails from './Pages/tutor-details/index.jsx';
import Policy from './Components/policy/Policy.jsx';
import Terms from './Components/terms/Terms.jsx';
import Waitlist from './Components/waitlist/Waitlist.jsx';
import BoardOfDirectors from './Components/bod/BoardOfDirectors.js';
import Advisors from './Components/Advisor/Advisor.js';
import Login from './Pages/Login.jsx';
import CreateAccount from './Pages/CreateAccount.jsx';
import ApplyAsVIP from './Pages/apply-as-vip/index.jsx';
import JobDescriptionPage from './Pages/job-description/index.jsx';
import ScrollToTop from './utils/ScrollToTop.js';
import OfferingBrowserPage from './Pages/offering/index.jsx';
import OfferingDetailPage from './Pages/offering/components/OfferingDetailPage.jsx';
import AcademicTutoring from './Pages/academic-tutoring/index.jsx';
import StandardizedTesting from './Pages/standardized-testing/index.jsx';
import TutorCrm from './Pages/tutor-crm/index.jsx';
import NexusApp from './Pages/NexusApp';

function App() {
  return (
    <Router>
      {/* <Header /> */}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/partnerships" element={<Partnerships />} />
        <Route path="/bod" element={<BoardOfDirectors />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/advisor" element={<Advisors />} />
        <Route path="/tutors" element={<TutorBrowserPage />} />
        <Route path="/offerings" element={<OfferingBrowserPage />} />
        <Route path="/offerings/:id" element={<OfferingDetailPage />} />
        <Route path="/tutor-details" element={<TutorDetails />} />
        <Route path="/tutor-crm" element={<TutorCrm />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/tos" element={<Terms />} />
        <Route path="/waitlist" element={<Waitlist />} />
        {/* <Route path="/tutor-details" element={<TutorDetails />} /> */}
        {/* <Route path="/terms-and-condition" element={<Terms />} /> */}
        <Route path="/nexus-app" element={<NexusApp />} />
        <Route path="/pricing" element={<ComingSoon />} />
        <Route path="/login" element={<Login />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/apply-as-vip" element={<ApplyAsVIP />} />
        <Route path="/products/academic-courses" element={<AcademicCourses />} />
        <Route path="/products/academic-tutoring" element={<AcademicTutoring />} />
        <Route path="/products/college-counseling" element={<CollegeCounseling />} />
        <Route path="/products/standardized-testing" element={<StandardizedTesting />} />
        <Route path="/job-description" element={<JobDescriptionPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
